<template>
  <roe-error-message :field="design.age_requirement_employee_deferrals">
    <v-select
      v-model="design.$model.age_requirement_employee_deferrals"
      :options="[
        { code: 0, label: 'No' },
        { code: 1, label: 'Yes, one requirement for all employees' },
        {
          code: 2,
          label: 'Yes, multiple requirements for different employees'
        }
      ]"
      :reduce="label => label.code"
      @input="onChange()"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeAgeRequirementSelect",
  mixins: [ResetDesignAttributesMixin],
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    onChange() {
      this.resetAttributes(this.design, "age_requirement_employee_deferrals");
      if (+this.design.$model.age_requirement_employer_match === 1) {
        this.design.$model.age_requirement_match_years = this.design.$model.age_requirement_years;
        this.design.$model.age_requirement_match_months = this.design.$model.age_requirement_months;
      }

      if (+this.design.$model.age_requirement_profit_sharing === 1) {
        this.design.$model.age_requirement_profit_sharing_years = this.design.$model.age_requirement_years;
        this.design.$model.age_requirement_profit_sharing_months = this.design.$model.age_requirement_months;
      }
    }
  }
};
</script>
